import React, { memo, useEffect, useState } from 'react'
import { Box, Grid, List, ListItem, ListItemText, Pagination, Popover, Table, TableBody, TableCell, TableRow } from '@mui/material';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from "lodash/isEmpty";
import TableHeader from './TableHeader';
import EditRowComponent from './Rows/EditRow';
import ViewRowComponent from './Rows/ViewRow';
import { getDataFromLFStorage, LFStorageKeys, saveDataInLFStorage } from '../../../../services/storage/LFStorage';
import { DOMAIN_ONSHIP } from '../../../../utils/constants';
import store from '../../../../state/configureStore';
import { handleMessageTypeTable } from '../../../../state/actionsHelpers/tabStackActionsHelpers/message-type-table';
import { useDispatch } from 'react-redux';
import { ButtonStyles } from './Rows/ViewRow/Styled';
import { uuidGenerator } from '../../../../utils/general';
import { handlePromptOnClose, setTabState } from '../../../../state/actions/tabStack';
import { ImagePath } from '../../../../assets/ImagePath';
import CachedImage from '../../../common/CachedImage';
import { isArray } from 'lodash';
import { setAddManuallayRow } from '../../../../state/actions/filters';


const FMTableComponent = ({
    message,
    parentTabId,
    parentDocId,
    conversationId,
    optionsDetails,
    showMandatory,
    setShowMandatory,
    handleAction,
    handleSelectAllRows,
    setSelectedRow,
    selectedRow,
    showCheckbox,
    handleInlineFormAction,
    setDisableParentSaveButton,
    disableSubmitFromParent,
    parentOptions = null
}) => {

    const [rows, setRows] = useState([]);

    const [options, setOptions] = useState(optionsDetails);
    const [isRowMenuAvialable, setIsRowMenuAvailable] = useState(false);
    const [isSectionId, setIsSectionId] = useState(false);

    const [isMenuPopUpOpen, setIsMenuPopUpOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedMenuRow, setSelectedMenuRow] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [disableSubmit, setDisableSubmit] = useState(
        disableSubmitFromParent && disableSubmitFromParent === false
            ? true
            : disableSubmitFromParent === true
                ? false
                : '' || true
    );

    const userDomain = store.getState().domain?.selectedDomain || null
    const dispatch = useDispatch();
    const userId = store.getState().user?.user?.userId;


    useEffect(() => {
        if (options?.sectionId && options?.sectionId != null) {
            setIsSectionId(true);
        }
    }, []);


    useEffect(() => {
        const readOnlyFields = {};
        // console.log("window.lastMsgFields : ", window.lastMsgFields)
        window.lastMsgFields &&
            window.lastMsgFields.map((field) => (readOnlyFields[field.id] = field));

        if (message) {
            // changing the values based on the message received
            if (window.lastMsgFields && window.lastDocIdChanged) {
                const readOnlyKeys = Object.keys(readOnlyFields);
                message = message.map((ele) => {
                    let fields = ele[window.lastDocIdChanged]?.fields;
                    if (fields) {
                        fields = fields.map((field) => {
                            // if the field present in the message change it
                            if (readOnlyKeys.includes(field.id)) {
                                field.readOnly = readOnlyFields[field.id].readOnly;
                            }
                            return field;
                        });
                        ele[window.lastDocIdChanged].fields = fields;
                    }
                    return ele;
                });
            }
            setRows(message);
        }

        if (optionsDetails) {
            let tempOptions = cloneDeep(optionsDetails);
            setOptions(tempOptions);
        }

        return () => {
            if (!optionsDetails?.openDrawer) setRows([]);
        };
    }, [message, optionsDetails]);


    useEffect(() => {
        const hasRowMenu = rows.some((row) => {
            const firstRow = Object.values(row || {})[0];

            return (
                firstRow?.rowOptions &&
                Object.keys(firstRow.rowOptions).length > 0 &&
                firstRow.rowOptions.rowMenu !== null &&
                firstRow.rowOptions.rowMenu?.length > 0
            );
        });

        setIsRowMenuAvailable(hasRowMenu);
    }, [rows]);


    const onSelectRow = (e, row) => {
        const rowId = Object.keys(row)[0];

        if (e.target.checked) {
            const isAlreadySelected = selectedRow?.some(
                (item) => Object.keys(item)[0] === rowId
            );
            if (!isAlreadySelected) {
                setSelectedRow([...(selectedRow || []), row]);
            }
        } else {
            const updatedRows = selectedRow?.filter(
                (item) => Object.keys(item)[0] !== rowId
            );
            setSelectedRow(updatedRows);
        }
    };


    // const handleSelectAllRows = (e) => {
    //     if (e.target.checked) {
    //         setSelectedRow(rows);
    //     } else {
    //         setSelectedRow(null);
    //     }
    // };


    const handlePageChange = (event, page) => {
        handleAction("pageChange", { newPage: page }, null, null, null, true);
    };


    const onAddRowConfirm = async (row) => {
        // Remove record from LFStorage
        setShowMandatory(false);
        if (setDisableParentSaveButton) {
            setDisableParentSaveButton(false)
        }

        let tableBuffer = (await getDataFromLFStorage(userId, LFStorageKeys.FMTABLE_EDIT_BUFFER)) || [];
        if (!isEmpty(tableBuffer)) {
            let newTableBuffer = tableBuffer.filter(
                (item) => Object.keys(item)[0] !== Object.keys(row)[0]
            );
            saveDataInLFStorage(LFStorageKeys.FMTABLE_EDIT_BUFFER, newTableBuffer);
        }

        let newlyAddedRow;
        if (Object.values(row)[0].rowOptions?.newRow === true) {
            newlyAddedRow = true;
        }

        Object.values(row)[0].rowOptions = {
            ...Object.values(row)[0].rowOptions,
            editRow: false,
            newRow: false,
        };

        let formMessage = {
            message: {
                fields: [row],
            },
            options: {
                action: "change",
                newRow: newlyAddedRow,
                controlId: optionsDetails.controlId,
                tableId: optionsDetails.tableId,
                tabId: optionsDetails?.parent?.length || optionsDetails.sectionId
                    ? parentTabId
                    : optionsDetails.tabId,
                parentDocId,
                parent: optionsDetails.parent,
                sectionId: optionsDetails.sectionId ? optionsDetails.sectionId : null,
            },
            updateOptions: true,
            updatedOrNewfield: row
        };
        !newlyAddedRow && delete formMessage.options.newRow;
        handleInlineFormAction(
            "onSave",
            Object.keys(row)[0],
            null,
            Object.values(row)[0].fields,
            newlyAddedRow
        );
        dispatch(setTabState(false))
        dispatch(handleMessageTypeTable(conversationId, formMessage, true, true));
    };


    const handleEditRowMenu = async (e, row) => {
        if (Object.values(row)[0].rowOptions?.newRow === true) {
            Object.values(row)[0].rowOptions = {
                ...Object.values(row)[0].rowOptions,
                editRow: true,
                newRow: true,
            };
        } else {
            Object.values(row)[0].rowOptions = {
                ...Object.values(row)[0].rowOptions,
                editRow: true,
            };
        }
        Object.values(row)[0].fields.forEach((fld) => {
            fld.options =
                fld.options && Object.keys(fld.options).length
                    ? fld.options
                    : options.columnTemplate.find((tpl) => fld.id === tpl.id)?.options;
        });
        let formMessage = {
            message: {
                fields: Object.values(row)[0].fields,
            },
            options: {
                action: "change",
                controlId: optionsDetails.controlId,
                tableId: optionsDetails.tableId,
                tabId: optionsDetails?.parent?.length || optionsDetails.sectionId
                    ? parentTabId
                    : optionsDetails.tabId,
                parentDocId,
                parent: optionsDetails.parent,
                docId: Object.keys(row)[0],
                rowOptions: Object.values(row)[0].rowOptions,
                sectionId: optionsDetails.sectionId ? optionsDetails.sectionId : null,
            },
            updateOptions: true
        };
        let tableBuffer = (await getDataFromLFStorage(userId, LFStorageKeys.FMTABLE_EDIT_BUFFER)) || [];

        // // check if in cache same row is not present
        if (isEmpty(tableBuffer.filter((bufRow) => Object.keys(bufRow)[0] === Object.keys(row)[0])) || isArray(tableBuffer) && tableBuffer.length === 0) {
            tableBuffer.push(row);
            saveDataInLFStorage(LFStorageKeys.FMTABLE_EDIT_BUFFER, tableBuffer);
        }
        dispatch(setTabState(false));
        dispatch(handleMessageTypeTable(conversationId, formMessage, true, true));
    };


    const handleDeleteRowMenu = (row) => {
        if (options?.sendPreDeleteAction) {
            // show modal
            handleAction(
                "onPreDelete",
                row,
                null,
                Object.keys(row)[0],
                Object.values(row)?.rowOptions?.newRow
            );
        } else {
            handleDeleteRowMenuWithoutConfirm(row);
        }
    };


    const handleDeleteRowMenuWithoutConfirm = (row) => {
        Object.values(row)[0].rowOptions = {
            ...Object.values(row)[0].rowOptions,
            deleted: true,
        };
        handleAction(
            "onDelete",
            row,
            null,
            Object.keys(row)[0],
            Object.values(row)?.rowOptions?.newRow
        );
        let updatedRow = rows.filter((item) => {
            if (Object.keys(item)[0] !== Object.keys(row)[0]) {
                return item;
            }
        });

        let formMessage = {
            message: {
                update: updatedRow,
            },
            options: {
                action: "change",
                controlId: optionsDetails.controlId,
                tableId: optionsDetails.tableId,
                tabId: optionsDetails?.parent?.length || optionsDetails.sectionId
                    ? parentTabId
                    : optionsDetails.tabId,
                parentDocId,
                parent: optionsDetails.parent,
                docId: Object.keys(row)[0],
                sectionId: optionsDetails.sectionId ? optionsDetails.sectionId : null,
            },
        };
        dispatch(setTabState(false))
        dispatch(handleMessageTypeTable(conversationId, formMessage, true));
        dispatch(handlePromptOnClose(conversationId));
    };


    const createNewRow = () => {
        if (setDisableParentSaveButton) {
            setDisableParentSaveButton(true)
        }

        setShowMandatory(true);
        setDisableSubmit(false);
        let docId = uuidGenerator();
        if (options.columnTemplate?.length > 0) {
            options.columnTemplate.forEach((data) => {
                if ('value' in data) {
                    delete data.value;
                }
            });
        }

        const newRow = {
            fields: cloneDeep(options.columnTemplate),
            rowOptions: {
                newRow: true,
            },
        };
        let formMessage = {
            message: {
                update: [...rows, { [docId]: newRow }],
            },
            options: {
                action: "change",
                controlId: optionsDetails.controlId,
                tableId: optionsDetails.tableId,
                tabId: optionsDetails?.parent?.length || optionsDetails.sectionId
                    ? parentTabId
                    : optionsDetails.tabId,
                parentDocId,
                parent: optionsDetails.parent,
                docId,
                sectionId: optionsDetails.sectionId ? optionsDetails.sectionId : null,
            },
        };
        dispatch(setTabState(false));
        dispatch(setAddManuallayRow(true));
        dispatch(handleMessageTypeTable(conversationId, formMessage, true));
    };


    const onRowMenuSelect = (row, e) => {
        setMenuRow(row);
        setAnchorEl(e.currentTarget);

        const rowSpecificRowMenu = row != null ? row[Object.keys(row)[0]]?.rowOptions?.rowMenu : null;
        const tableSpecificRowMenu = options?.rowMenu;
        const selectedRowMenu = rowSpecificRowMenu || tableSpecificRowMenu;

        setSelectedMenuRow(selectedRowMenu);
        setIsMenuPopUpOpen(true);
    };


    const onDiscardRow = async (row) => {
        if (setDisableParentSaveButton) setDisableParentSaveButton(false);
        dispatch(setAddManuallayRow(false));

        setShowMandatory(false);
        let newlyAddedRow;
        if (Object.values(row)[0].rowOptions?.newRow === true) {
            newlyAddedRow = true;
        }

        if (Object.values(row)[0].rowOptions?.newRow) {
            let filterRows = rows.filter(
                (item) => Object.keys(item)[0] !== Object.keys(row)[0]
            );
            let formMessage = {
                message: {
                    update: filterRows,
                },
                options: {
                    action: "change",
                    newRow: newlyAddedRow,
                    controlId: optionsDetails.controlId,
                    tableId: optionsDetails.tableId,
                    tabId: optionsDetails?.parent?.length || optionsDetails.sectionId
                        ? parentTabId
                        : optionsDetails.tabId,
                    parentDocId,
                    parent: optionsDetails.parent,
                    sectionId: optionsDetails.sectionId ? optionsDetails.sectionId : null,
                },
            };
            !newlyAddedRow && delete formMessage.options.newRow;
            handleInlineFormAction(
                "onDiscard",
                Object.keys(row)[0],
                null,
                row,
                newlyAddedRow
            );
            dispatch(handleMessageTypeTable(conversationId, formMessage, true));
            setTimeout(() => { dispatch(handlePromptOnClose(conversationId)); }, 2000);
        } else {
            let tableBuffer = await getDataFromLFStorage(userId, LFStorageKeys.FMTABLE_EDIT_BUFFER)
            let oldRow = null;
            if (!isEmpty(tableBuffer)) {
                let newTableBuffer = tableBuffer.filter(
                    (item) => Object.keys(item)[0] !== Object.keys(row)[0]
                );
                oldRow = tableBuffer.filter(
                    (item) => Object.keys(item)[0] === Object.keys(row)[0]
                )[0];
                saveDataInLFStorage(LFStorageKeys.FMTABLE_EDIT_BUFFER, newTableBuffer);
            }

            let formMessage = {
                message: {
                    fields: Object.values(oldRow)[0].fields,
                },
                options: {
                    action: "change",
                    newRow: newlyAddedRow,
                    controlId: optionsDetails.controlId,
                    tableId: optionsDetails.tableId,
                    tabId: optionsDetails?.parent?.length || optionsDetails.sectionId
                        ? parentTabId
                        : optionsDetails.tabId,
                    parentDocId,
                    parent: optionsDetails.parent,
                    docId: Object.keys(row)[0],
                    sectionId: optionsDetails.sectionId ? optionsDetails.sectionId : null,
                    rowOptions: {
                        ...Object.values(oldRow)[0].rowOptions,
                        editRow: false,
                    },
                },
                updateOptions: true
            };
            !newlyAddedRow && delete formMessage.options.newRow;
            handleInlineFormAction(
                "onDiscard",
                Object.keys(oldRow)[0],
                null,
                oldRow,
                newlyAddedRow
            );
            dispatch(setTabState(false));
            dispatch(handleMessageTypeTable(conversationId, formMessage, true));
            setTimeout(() => { dispatch(handlePromptOnClose(conversationId)); }, 2000);
        }
    };


    const onMenuOptionClick = (row, menuOption) => {
        const rowKey = Object.keys(row)[0];
        const fields = row[rowKey]?.fields || [];

        const tempRow = fields.reduce((acc, field) => {
            acc[field.id] = field.value;
            return acc;
        }, {});

        setIsMenuPopUpOpen(false);
        setAnchorEl(null);
        handleAction("onMenuAction", { option: menuOption, row: tempRow, }, null, rowKey);
    };

    const renderEmptyState = (message) => {
        return (
            <TableRow>
                <TableCell colSpan={20}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '150px',
                            gap: 1
                        }}
                    >
                        <CachedImage
                            image={ImagePath.emptyTable}
                            imgKey="table-empty"
                            alt='table-empty'
                            className="w-[140px] h-[100px]"
                        />
                        <Box
                            sx={{
                                fontSize: 14,
                                fontWeight: 'bold',
                                textAlign: 'center',
                                color: "#000000",
                            }}
                        >
                            {message}
                        </Box>
                    </Box>
                </TableCell>
            </TableRow>
        );
    };

    if (options) {
        return (
            <Box className="table-wrapper">
                <Table className='inner-table-main'>
                    <TableHeader
                        rows={rows}
                        options={options}
                        selectedRow={selectedRow}
                        showMandatory={showMandatory}
                        showCheckbox={showCheckbox}
                        isRowMenuAvialable={isRowMenuAvialable}
                        handleSelectAllRows={handleSelectAllRows}
                    />
                    <TableBody
                    >
                        {options?.emptyStateMessage
                            && options.emptyStateMessage != ""
                            && rows.length == 0
                            && renderEmptyState(options.emptyStateMessage)}
                        {Array.isArray(rows) &&
                            rows.filter((row) => !Object.values(row)[0]?.rowOptions?.deleted)
                                .map((row, index) => {
                                    const rowData = Object.values(row)[0];
                                    const { rowOptions, fields } = rowData;
                                    const onlineStatus = fields?.find((col) => col.primaryKey)?.onlineStatus || 0;

                                    return rowOptions?.editRow || rowOptions?.newRow ? (
                                        <EditRowComponent
                                            key={index}
                                            row={row}
                                            options={options}
                                            parentTabId={parentTabId}
                                            onlineStatus={onlineStatus}
                                            selectedRow={selectedRow}
                                            onDiscard={onDiscardRow}
                                            onSelectRow={onSelectRow}
                                            onConfirm={onAddRowConfirm}
                                            handleAction={handleAction}
                                            setShowMandatory={setShowMandatory}
                                            onRowInputChange={handleEditRowMenu}
                                            handleInlineFormAction={handleInlineFormAction}
                                            disableSubmit={disableSubmit}
                                            setDisableSubmit={setDisableSubmit}
                                            setDisableParentSaveButton={setDisableParentSaveButton}
                                        />
                                    ) : (
                                        <ViewRowComponent
                                            key={index}
                                            row={row}
                                            options={options}
                                            parentTabId={parentTabId}
                                            onlineStatus={onlineStatus}
                                            selectedRow={selectedRow}
                                            onSelectRow={onSelectRow}
                                            handleAction={handleAction}
                                            onConfirm={onAddRowConfirm}
                                            showCheckbox={showCheckbox}
                                            isSectionId={isSectionId}
                                            onRowMenuSelect={(event) => onRowMenuSelect(row, event)}
                                            handleEditMenu={handleEditRowMenu}
                                            handleDeleteMenu={handleDeleteRowMenu}
                                            disableSubmit={disableSubmit}
                                            setDisableSubmit={setDisableSubmit}
                                            setDisableParentSaveButton={setDisableParentSaveButton}
                                        />
                                    );
                                })}
                    </TableBody>
                </Table>

                {options.pages && options.pages.currentPage && (options.pages.totalPages && options.pages.totalPages > 1) && (
                    <Grid className="pazination-conatiner">
                        <Grid>
                            <Pagination
                                className='table-pazination'
                                color="primary"
                                boundaryCount={2}
                                count={options.pages.totalPages}
                                page={options.pages.currentPage}
                                onChange={handlePageChange}
                            />
                        </Grid>
                    </Grid>)
                }

                <Grid container sx={{ marginLeft: "12px", marginBlock: "12px" }}>
                    <Grid >
                        {options?.addNewRows && (
                            <ButtonStyles variant="contained" onClick={() => createNewRow()} disabled={parentOptions?.readOnly}>
                                {options?.addNewRowsLabel || "Add new vessel to this fleet"}
                            </ButtonStyles>
                        )}
                    </Grid>
                </Grid>

                {/*Row-level popover menu */}
                {menuRow && isMenuPopUpOpen && (
                    <Popover
                        id="row-menu-popover"
                        open={isMenuPopUpOpen}
                        anchorEl={anchorEl}
                        onClose={() => setIsMenuPopUpOpen(false)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    >
                        <List dense>
                            {selectedMenuRow?.map((menu, index) => (
                                <ListItem
                                    key={menu.name || index}
                                    button
                                    onClick={() => onMenuOptionClick(menuRow, menu.name)}
                                    sx={{ cursor: 'pointer', fontSize: '10px' }}
                                >
                                    <ListItemText className='under-small-text'
                                        primary={menu.name}
                                        sx={{
                                            ...(userDomain === DOMAIN_ONSHIP && {
                                                fontFamily: "Figtree-Regular",
                                            }),
                                        }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Popover>
                )}
            </Box>
        )
    };

    return null
};

export default memo(FMTableComponent);
